module.exports = __webpack_public_path__ + "login-banner.aca9bdf1420f08cae645.png";


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/assets/img/login-banner.png
// module id = ../../../../../src/assets/img/login-banner.png
// module chunks = main